import { RequestEvent } from 'common/event';
import { LookupItem } from 'runtime/data/lookupitem';

export class FilteredLookupItemsRequested extends RequestEvent<FilteredLookupItemsRequested, LookupItem[]> {
    constructor(public fieldName: string, public fieldContext: string, public filter: string) {
        super();
    }
}